import styled from 'styled-components';
import { horizontalSpacing } from 'tabview/pagesView/constants';
import { t, type I18nLocale } from '@ardoq/i18n';
import { pagesContextMenuName } from './contextMenu';
import { ComponentPath } from 'tabview/pagesView/ComponentPath';
import type { ComponentPathData } from 'tabview/pagesView/types';

type ReferencePopoverProps = {
  componentPath: ComponentPathData;
  isSource: boolean;
  displayText: string;
  i18nLocale: I18nLocale;
};

const PathWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const TextWrapper = styled.div`
  margin-right: ${horizontalSpacing.SMALL};
`;

const ReferencePopoverContentWrapper = styled.div`
  max-width: 448px;
`;

const DisplayText = ({
  displayText,
  i18nLocale,
}: Pick<ReferencePopoverProps, 'displayText' | 'i18nLocale'>) => {
  return displayText && displayText.length ? (
    <>
      <br />{' '}
      {t(
        i18nLocale,
        'tabview:pagesView.referencePopover.displayTextLabel',
        'Display text:'
      )}{' '}
      {displayText}
    </>
  ) : null;
};

export const ReferencePopover = ({
  componentPath,
  isSource,
  displayText,
  i18nLocale,
}: ReferencePopoverProps) => (
  <ReferencePopoverContentWrapper data-context-menu={pagesContextMenuName}>
    <PathWrapper>
      <TextWrapper>
        {isSource
          ? t(
              i18nLocale,
              'tabview:pagesView.referencePopover.referenceFrom',
              'Reference from:'
            )
          : t(
              i18nLocale,
              'tabview:pagesView.referencePopover.referenceTo',
              'Reference to:'
            )}{' '}
      </TextWrapper>
      <ComponentPath
        path={componentPath.path}
        workspace={componentPath.workspace}
        small={false}
      />
    </PathWrapper>
    <DisplayText displayText={displayText} i18nLocale={i18nLocale} />
  </ReferencePopoverContentWrapper>
);
